export default "/images/vendor/flag-icon-css/flags/4x3/io.svg?e31ca9aa9209d9b76a0b7511c21e9fc0";